export const sortOnName = (a, b, prop = 'name') => {
    if (!a || !b) return 0;

    const nameA = (typeof a === 'string' ? a : a[prop]).toUpperCase(); // ignore upper and lowercase
    const nameB = (typeof b === 'string' ? b : b[prop]).toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }

    // names must be equal
    return 0;
};
